import {evite} from 'evite';
import {ID_PREFIX_BY_CONFIG_KEY} from '~/ads/constants';
import {getAdDimensions} from '~/ads/utils';

interface GetAdConfigParams {
  index: number;
  isLargishAndUp: boolean;
  configKey: 'topLeaderboard' | 'leaderboard' | 'sidePanel' | 'photoShare' | 'photoShareGallery' | 'createFlowDesktop' | 'createFlowMobile' | 'viewInviteTopDesktop' | 'viewInviteTopMobile' | 'viewInviteMidDesktop' | 'viewInviteMidMobile' | 'viewInviteBottomDesktop' | 'viewInviteBottomMobile';
}

export const getAdConfig = ({index, isLargishAndUp, configKey}: GetAdConfigParams) => {
    const {dfp} = evite;
    const sidePanel = configKey === 'sidePanel';
    const GoogleBannerAdIdWithIndex = `${ID_PREFIX_BY_CONFIG_KEY[configKey]}${index ? `-${index}` : ''}`;
    const adUnitId = isLargishAndUp || sidePanel ? dfp.DESKTOP_ID : dfp.MOBILE_ID;
    const adSlotUrl = dfp.compactUrl(adUnitId, GoogleBannerAdIdWithIndex);

    const dimensions = getAdDimensions(configKey, isLargishAndUp);
    return {
        GoogleBannerAdIdWithIndex,
        adSlotUrl,
        dimensions,
    };
};
